import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import config from '../configs';

function EasylinkModalTitle({ offer, wasAlreadyLinked }) {
  const { displayRate, currency, rclonMerchantName } = offer;
  const {
    getEasyLinkTitleLinkedBefore, getEasyLinkTitleLinkedNow,
    getEasyLinkMottoLinkedBefore, getEasylinkMottoLinkedNow,
  } = config;
  const formattedMerchantName = rclonMerchantName.endsWith('s') ? `${rclonMerchantName}'` : `${rclonMerchantName}'s`;

  const titleLinkedBefore = getEasyLinkTitleLinkedBefore(displayRate, currency, rclonMerchantName);
  const titleLinkedNow = getEasyLinkTitleLinkedNow(formattedMerchantName);

  const mottoLinkedBefore = getEasyLinkMottoLinkedBefore(displayRate, currency, rclonMerchantName);
  const mottoLinkedNow = getEasylinkMottoLinkedNow(formattedMerchantName);

  if (wasAlreadyLinked) {
    return <SectionTitle id="mn_dialogTitle" title={titleLinkedBefore} motto={mottoLinkedBefore} />;
  }

  return <SectionTitle id="mn_dialogTitle" title={titleLinkedNow} motto={mottoLinkedNow} />;
}

export default (props) => <ComponentErrorBoundary><EasylinkModalTitle {...props} /></ComponentErrorBoundary>;
